export default {
  detectIframe({ commit }) {
    if (window.Cypress) {
      commit('UPDATE_INSIDE_IFRAME', false);
    } else {
      commit('UPDATE_INSIDE_IFRAME', window.location !== window.parent.location);
    }
  },
};
